<template>
    <div class="main">
        <my_menu2 page_name="面试流程配置" back_type="close" back_icon="md-close"></my_menu2>
        <div style="height: 45px;"></div>
        <div class="content">
            <div>
                <Tabs v-model="tabs_index" @on-click='click_tabs'>
                    <TabPane v-for="(item, i) in class_list" :key="i" :label="item.label" :name="item.value">

                        <div class="class_div">
                            当前大类ID: {{ item.value }}
                        </div>
                    </TabPane>
                    <template #extra>
                        <Button v-if="show_option" style="font-size:10px" @click="add_tabs" size="small">
                            <Icon type="md-add" />增加大类
                        </Button>
                        <Switch size="small" v-model="show_option" />
                    </template>
                </Tabs>
            </div>
            <div class="button_div">
                <Button v-if="show_option" style="font-size:10px" @click="(add_flow_show = true)" size="small"
                    type="primary">
                    <Icon type="md-add" />增加流程
                </Button>
            </div>
            <div>
                <div class="flow_box" v-for="(item, i) in flow_list" :key="i">

                    <div class="flow_title">
                        {{ item.label }}
                        <span class="flow_value">({{ item.value }})</span>

                    </div>

                    <div class="xiayibu">
                        下一步
                        <span>
                            <Icon type="md-arrow-forward" />
                        </span>
                    </div>
                    <div class="next_flow_id">
                        {{ item.next_flow_id }}
                        <Cascader v-if="show_option" :id="i" size="small" @on-change="next_flow_change($event, item)"
                            :data="flow_options" v-model="item.next_flow_id" v-width="200" />
                    </div>

                </div>
            </div>


        </div>
        <Modal v-model="add_class_show" title="添加大类" :footer-hide="true">
            <Input v-model="add_class_data.name" placeholder="类名称" style="width: 200px" />
            <div class="add_class_div">
                <Button style="font-size:10px" @click="add_class" type="primary">
                    <Icon type="md-add" />确认添加
                </Button>
            </div>
        </Modal>
        <Modal v-model="add_flow_show" title="添加流程" :footer-hide="true">
            <Input v-model="add_class_data.name" placeholder="类名称" style="width: 200px" />
            <div class="add_class_div">
                <Button style="font-size:10px" @click="add_class2" type="primary">
                    <Icon type="md-add" />确认添加
                </Button>
            </div>
        </Modal>
    </div>



</template>

<script>
import my_menu2 from '@/component/menu/menu2.vue'
import { http } from "@/utils/http.js";

export default {
    components: {
        my_menu2
    },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            select_class: '',
            show_option: false,
            class_list: [],
            flow_list: [],
            flow_options: [],
            add_class_show: false,
            add_class_data: {
                name: ""
            },
            add_flow_show: false,

        }
    },

    mounted() {
        this.window_change()
        this.get_flow_optionst()
    },

    methods: {

        add_class2() {
            var that = this
            var obj = {
                name: this.add_class_data.name,
                parent_id: this.select_class
            }
            http("post", process.env.VUE_APP_HOST + "/interview_manage/flow/add_flow", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_flow_list()
                        that.add_flow_show = false

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                }
            ).catch((res) => {
                console.log(res, '请求出错')
            })
        },


        add_class() {
            var that = this
            var obj = {
                name: this.add_class_data.name,
                parent_id: ''
            }
            http("post", process.env.VUE_APP_HOST + "/interview_manage/flow/add_flow", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_class_list()
                        that.add_class_show = false
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                }
            ).catch((res) => {
                console.log(res, '请求出错')
            })
        },

        add_tabs(e) {
            this.add_class_show = true
        },

        click_tabs(e) {
            this.select_class = e
            this.get_flow_list()

        },

        next_flow_change(e, item) {
            console.log(e, item)
            var that = this
            var obj = {
                current_id: item.value,
                next_flow_id: e[1]
            }
            http("post", process.env.VUE_APP_HOST + "/interview_manage/flow/next_flow_update", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                }
            ).catch((res) => {
                console.log(res, '请求出错')
            })

        },

        //获取流程数据
        get_flow_optionst() {
            var that = this
            var obj = {
            }
            http("post", process.env.VUE_APP_HOST + "/interview_manage/flow/flow_options", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.flow_options = res.data.flow_options
                        console.log(that.flow_options)
                        that.get_class_list()
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                }
            ).catch((res) => {
                console.log(res, '请求出错')
            })
        },


        //获取流程列表
        get_flow_list() {
            var that = this
            var obj = {
                parent_id: this.select_class
            }
            http("post", process.env.VUE_APP_HOST + "/interview_manage/flow/flow_list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.flow_list = res.data.flow_list
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                }
            ).catch((res) => {


                console.log(res, '请求出错')
            })
        },


        //获取类列表
        get_class_list() {
            var that = this
            var obj = {
            }
            http("post", process.env.VUE_APP_HOST + "/interview_manage/flow/class_list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.class_list = res.data.class_list
                        that.select_class = res.data.class_list[0]['value']
                        that.get_flow_list()
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }

                }
            ).catch((res) => {
                console.log(res, '请求出错')
            })
        },

        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        }
    }
}
</script>

<style scoped>
.class_div {
    padding: 10px;

}

.flow_value {
    padding-left: 10px;
    font-size: 13px;
    color: #ccc;
    font-weight: 400;
}

.next_flow_id {
    font-size: 13px;
    font-weight: 600;
}

.button_div {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
}

.add_class_div {
    padding: 10px 10px 0 10px;
    display: flex;
    justify-content: flex-end;
}

.flow_title {
    width: 240px;
    flex-shrink: 0;
    font-weight: 600;
    color: #333;
}

.xiayibu {
    font-size: 13px;
    color: #333;
    margin-right: 20px;

}

.flow_box {
    padding: 15px 20px;
    background-color: #f2f3f5;
    color: #333;
    margin-bottom: 10px;
    display: flex;

}

.content_page {
    display: flex;
    justify-content: center;
    padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
    margin-bottom: 10px;
}

.circular {
    width: 25px;
    height: 25px;
}

.table_box {
    position: relative;
}

.add_sys_button {
    margin-top: 20px;
    text-align: right;
}

.form_item_title {
    flex-shrink: 0;
    width: 100px;
}

.form_item {
    display: flex;
    align-items: center;
}

.options {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.content {
    background-color: #fff;
    padding:0 20px;
    min-height: calc(100vh - 50px);
}

.main {
    background: #f5f7f9;
    min-height: 100vh;
}
</style>